import React from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import moment from 'moment';

const formatarMonetario = valor => {
  if (valor === null || valor === undefined) return '-';
  return Number(valor).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatarData = data => {
  if (!data) return '-';
  return moment(data).format('DD/MM/YYYY');
};

export default function ModalDetalhamento({ show, onHide, detalhamento, prestador, intencao }) {
  if (!detalhamento || !prestador || !intencao) return null;

  const {
    vv,
    vv_liquido,
    exibir_vv_liquido,
    tipo_recebimento,
    vr_comissao,
    per_comissao,
    comissao_retida,
    sugerido,
    digitado,
    titulos,
  } = detalhamento;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '1rem' }}>
          Detalhamento de Recebimento
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Resumo estruturado */}
        <div className="modal-resumo-card">
          <div className="resumo-linha">
            <span className="resumo-label">Prestador</span>
            <span className="resumo-valor">
              {prestador.sigla} — {prestador.codigo_conta} — {prestador.apelido_conta}
            </span>
          </div>
          <div className="resumo-linha">
            <span className="resumo-label">Imóvel</span>
            <span className="resumo-valor">
              {intencao.codigo_ativo}
              {intencao.quadra ? ` (${intencao.quadra}/${intencao.lote})` : ''}
            </span>
          </div>
          <div className="resumo-linha">
            <span className="resumo-label">Pré-Venda</span>
            <span className="resumo-valor">{intencao.pre_venda}</span>
          </div>
          <div className="resumo-linha">
            <span className="resumo-label">VV</span>
            <span className="resumo-valor">{formatarMonetario(vv)}</span>
          </div>
          {!comissao_retida && exibir_vv_liquido && (
            <div className="resumo-linha">
              <span className="resumo-label">VV Líquido</span>
              <span className="resumo-valor">{formatarMonetario(vv_liquido)}</span>
            </div>
          )}
          {!comissao_retida && (
            <>
              <div className="resumo-linha">
                <span className="resumo-label">Rec. Tipo</span>
                <span className="resumo-valor">
                  {tipo_recebimento !== null && tipo_recebimento !== undefined
                    ? tipo_recebimento
                    : '-'}
                </span>
              </div>
              <div className="resumo-linha">
                <span className="resumo-label">Comissão</span>
                <span className="resumo-valor">
                  {formatarMonetario(vr_comissao)} ({formatarMonetario(per_comissao)}%)
                </span>
              </div>
            </>
          )}
        </div>

        {comissao_retida ? (
          <div className="comissao-retida-card">
            <FaExclamationTriangle
              style={{ fontSize: '1.4rem', color: '#dc3545' }}
            />
            <div className="retida-titulo">
              Comissão Retida no ato da Venda
            </div>
            <div className="retida-valores">
              <strong>Sugerido:</strong> {formatarMonetario(sugerido)}
              {' — '}
              <strong>Digitado:</strong> {formatarMonetario(digitado)}
            </div>
          </div>
        ) : (
          <>
            <div className="modal-titulos-scroll">
              <Table striped bordered hover size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th>Título</th>
                    <th>Valor</th>
                    <th>Vencimento</th>
                    <th>Bx</th>
                    <th>Dt.Baixa</th>
                    <th>*Tp.Baixa</th>
                  </tr>
                </thead>
                <tbody>
                  {titulos && titulos.length > 0 ? (
                    titulos.map((t, idx) => (
                      <tr key={idx}>
                        <td>
                          {t.codigo_titulo !== null && t.codigo_titulo !== undefined
                            ? t.codigo_titulo
                            : '-'}
                        </td>
                        <td>{formatarMonetario(t.valor)}</td>
                        <td>{formatarData(t.data_vencimento)}</td>
                        <td>{t.baixado || '-'}</td>
                        <td>{formatarData(t.data_baixa)}</td>
                        <td>{t.tipo_baixa || '-'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center text-muted py-2">
                        Nenhum título encontrado
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            <div className="legenda-tipos-baixa">
              *Tp.Baixa: (C)Pgto comissão / (R)Renegociação / (A)Antecipação / (X)Cancelamento
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
